import { useTranslation } from 'react-i18next';
import { Tooltip, Box } from '@mui/material';
import { Button } from '@atoms';
import { useExportAllAccountsFiltered, useIsAreasAdmin, useShowAreaFeature } from '@hooks';
import {
  dispersionClick,
  EVENT_FILE_DISPERSION_DOWNLOAD_ACCOUNTS,
} from '@modules/dispersions/fileDispersion/events';
import styles from './styles';

interface TemplateLinkDispersionProps {
  customerId: number;
  areaId?: string;
}
/**
 * React component for a prospect template link that triggers the download of a file.
 *
 * @function
 * @name TemplateLinkProspect
 * @returns {React.Component} A React component representing a link to download a file template.
 */
const TemplateLinkDispersion = ({
  customerId,
  areaId,
}: TemplateLinkDispersionProps): JSX.Element => {
  const { t } = useTranslation();
  const { isLoading, exportAllAccountsFiltered, error } = useExportAllAccountsFiltered();

  const { showAreaFeature } = useShowAreaFeature();
  const { isAreasAdmin } = useIsAreasAdmin();
  const validateArea = showAreaFeature && !isAreasAdmin ? !areaId : false;

  const disableButton = Boolean(error || isLoading || !customerId || validateArea);

  /** Handles the click event on the link. */
  const handlerClick = () => {
    dispersionClick(EVENT_FILE_DISPERSION_DOWNLOAD_ACCOUNTS);
    exportAllAccountsFiltered(customerId, { ...(areaId && { areaId }) });
  };

  return (
    <Box sx={{ ...styles.box }}>
      <Tooltip title={t('COMMON:TOOLTIP:PROSPECT')}>
        <Button
          onClick={handlerClick}
          disabled={disableButton}
          isLoading={isLoading}
          content={t('COMMON:ACCOUNT_LINK_TITLE')}
          variant='text'
          customStyle={styles.button}
        />
      </Tooltip>
    </Box>
  );
};

export default TemplateLinkDispersion;
